<div id="scroll-into-view"></div>
<app-current-account></app-current-account>

<h2>Die Anmeldung wurde erfolgreich eingereicht</h2>
<p>Wir müssen die Daten einem Plausibilitätscheck unterziehen und kontaktieren dich unter deiner registrierten E-Mail Adresse bzw. Telefonnummer.</p>
<p>Bei Fragen stehen wir gerne unter office@spitzaufschmankerl.at oder 0664/5501000 zur Verfügung.</p>